<template>
<div>
    <div class="bg-gradient"></div>
    <div class="main-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="search-holder mt-30 search-holder-list">
                        <div class="input-group">
                            <!-- <input type="text" class="form-control rounded-right" placeholder="Search Enquiry" /> -->
                            <input type="text" placeholder="Search by Client name" @input="(e) => (Filter = e.target.value)" :value="Filter" class="search form-control" @keyup.enter="FilterData" />
                            <svg v-if="Filter" @click="resetFilter" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background: new 0 0 512.001 512.001" xml:space="preserve" width="14" height="14" class="close r-70">
                                <g>
                                    <g>
                                        <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                              L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                              c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                              l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                              L284.286,256.002z" />
                                    </g>
                                </g>
                            </svg>
                            <div class="input-group-append align-fix" id="button-addon4">
                                <!-- <button class="btn btn-white rounded-right" :disabled="!Filter" @click="FilterData" type="button">Go</button> -->
                                <button class="btn btn-white rounded-right" :disabled="!Filter" @click="FilterData" type="button">
                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451" style="enable-background: new 0 0 451 451" xml:space="preserve">
                                        <g>
                                            <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                                          s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                                          C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                                          s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
                                        </g>
                                    </svg>
                                </button>
                                <button v-b-toggle.sidebar-right class="filter-menu btn btn-filter btn-white" type="button">
                                    <img src="@/assets/filter.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <span class="result-Text">{{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
                        </div>
                    </div>
                </div>
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card enquiry-card m-height">
                        <b-list-group class="list-group-flush">
                            <b-list-group-item v-for="item in GetAllMeetings" :key="item.id">
                                <div class="row">
                                    <div class="col-6 pr-1" @click="goToMeetingDetails(item)">
                                        <span class="name ellipses" v-if="item.client_name">{{item.client_name}}</span>
                                        <span class="project-name" v-if="item.start_date_time !== null || item.end_date_time !== null">{{`${item.start_date_time} - ${item.end_date_time}`}}</span>
                                    </div>
                                    <div class="col-6 pl-1 text-right">
                                        <span class="label label-tag" v-if="item.field_executive">{{item.field_executive}}</span>
                                        <!-- <button class="btn btn-danger ml-3" v-if="isDeleteAvailable" @click="deleteRecord($event, item)">Delete</button> -->
                                        <b-button v-b-modal.modal-1 v-if="isDeleteAvailable" @click="deleteRecord($event, item)">Delete</b-button>
                                        <!-- <b-button ref="delete-modal" hide-footer title="Using Component Methods" @click="deleteRecord">Delete</b-button> -->
                                    </div>
                                    <!-- Button trigger modal -->
                                    <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
                                        Launch demo modal
                                    </button> -->
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                </div>
            </div>
            <!-- <router-link to="/AddMeeting" class="float-btn"><img src="@/assets/plus.svg" alt=""></router-link> -->
            <div class="pagination-holder">
                <paginate v-if="totalPages > 1" v-model="pageNo" :page-count="totalPages" :click-handler="goToPage" :page-class="'page-item'" :page-link-class="'page-link'" :prev-link-class="'page-link'" :next-link-class="'page-link'" :disabled-class="'page-item disabled'" :container-class="'pagination justify-content-center'">
                </paginate>
            </div>
            <b-sidebar id="sidebar-right" ref="sidebar-right" title="Advance Search" bg-variant="white" backdrop right shadow>
                <template v-slot="{ hide }">
                    <div class="card form-card sidebar-form-card">
                        <b-form @submit.prevent="AdvancedFilter" @reset="resetAdvancedFilter">
                            <b-form-group label="Field Executive">
                                <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.user_ids" :searchable="true" placeholder="Field Executive" label="full_name" track-by="id" :options="userIdSettings" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="Display From Date">
                                <datetime type="datetime" v-model="AdvancedFilterMeeting.start_date" placeholder="Start Date And Time"></datetime>
                            </b-form-group>
                            <b-form-group label="Display To Date">
                                <datetime type="datetime" v-model="AdvancedFilterMeeting.end_date" placeholder="End Date And Time"></datetime>
                            </b-form-group>
                            <b-form-group label="Meeting Type">
                                <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.meeting_types" :searchable="true" placeholder="Meeting Type" label="text" track-by="value" :options="meetingTypesList" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="Team Lead">
                                <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.tl_id" :searchable="true" placeholder="Team Lead" label="full_name" track-by="id" :options="teamLeadList" :multiple="false" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="Manager">
                                <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.manager_id" :searchable="true" placeholder="Manager" label="full_name" track-by="id" :options="managerList" :multiple="false" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="">
                              <label>Resource Type</label>
                              <b-form-select v-model="AdvancedFilterMeeting.resource_type">
                                  <b-form-select-option :value="null" selected disabled>Select One</b-form-select-option>
                                  <b-form-select-option value='Enquiry'>Enquiry</b-form-select-option>
                                  <b-form-select-option value='PremiumEnquiry'>Premium Enquiry</b-form-select-option>
                              </b-form-select>
                          </b-form-group>
                            <b-form-group label="Enquiry Number">
                                <b-form-input class="form-multiselect" v-model="AdvancedFilterMeeting.enquiry_no" placeholder="Enquiry Number"></b-form-input>
                                <!-- <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.enquiry_no" :searchable="true" placeholder="Enquiry Number" label="text" track-by="value" :options="broker_categorization" :multiple="true" :taggable="false"></multiselect> -->
                            </b-form-group>
                            <b-form-group class="btn-fixed">
                                <b-button variant="primary" type="submit" block @click="hide">Search</b-button>
                                <b-button variant="primary-outline" block type="reset">Reset</b-button>
                            </b-form-group>
                        </b-form>
                    </div>
                </template>
            </b-sidebar>

            <!-- Modal -->
            <div>
                <b-modal ref="my-modal" id="modal-1" hide-footer>
                    <p class="my-4">Are you sure you want to delete</p>
                    <div class="text-right">
                        <button class="btn btn-success" @click="$refs['my-modal'].hide()">Cancel</button>
                        <button class="btn btn-danger ml-3" @click="deleteRecordFromModal">Delete</button>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</div>
</template>

  
<script>
import {
    paramsFromQuery,
    decodeMeetingSearchParams
} from "@/assets/scripts/utility.js";
import {
    Datetime
} from 'vue-datetime';
import Multiselect from 'vue-multiselect';
import qs from "qs";
import router from "../router";

export default {
    name: "Meeting",
    components: {
        datetime: Datetime,
        Multiselect
    },
    data() {
        return {
            GetAllMeetings: [],
            Filter: this.$route.query.search_query,
            total: 0,
            perPage: 0,
            meetingTypesList: [],
            allSettings: [],
            userIdSettings: [],
            teamLeadList: [],
            managerList: [],
            enquiryList: [],
            isDeleteAvailable: false,
            index: 0,
            selectedItem: null,
            AdvancedFilterMeeting: {
                user_ids: [],
                enquiry_no: "",
                start_date: null,
                end_date: null,
                tl_id: null,
                meeting_type: [],
                resource_type: null,
                manager_id: null
            }
        }
    },
    created() {
        sessionStorage.setItem("isFromMyMeetings", true);
        this.getMeetingTypesList();
        this.FetchAllMeetings();
    },
    watch: {
        $route(to, from) {
            this.FetchAllMeetings();
        },
    },
    methods: {
        deleteRecord(event, item) {
            this.index = this.GetAllMeetings.indexOf(item);
            this.selectedItem = item;
        },
        deleteRecordFromModal(){
            this.$axios.delete(`/enquiries/client_meetings/${this.selectedItem.id}`, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((res) => {
                    this.GetAllMeetings.splice(this.index, 1);
                    this.FetchAllMeetings();
                    this.$refs['my-modal'].hide()
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        goToMeetingDetails(item) {
            router.push({
                name: 'MeetingDetails',
                params: {
                    id: item.id
                }
            });
        },
        FetchAllMeetings() {
            let queryP = {}
            let advSearchParams;
            paramsFromQuery(queryP, this.$route.query);
            if (this.$route.query.is_advanced_search) {
                let searchParams = this.$route.query
                for (let key in searchParams) {
                    queryP[key] = searchParams[key];
                }
                advSearchParams = queryP
            }
            if (advSearchParams) {
                paramsFromQuery(queryP, advSearchParams);
            } else {
                paramsFromQuery(queryP, this.$route.query);
            }
            this.$axios.get(`/enquiries/client_meetings`, {
                params: queryP,
                paramsSerializer: (params) =>
                    qs.stringify(params, {
                        arrayFormat: "brackets"
                    }),
            }).then((res) => {
                this.GetAllMeetings = res.data.client_meeting;
                this.perPage = res.data.per_page;
                this.total = res.data.total_count;
            }).catch((err) => {
                console.log(err);
            });
        },
        getMeetingTypesList() {
            this.$axios.get("/enquiries/client_meetings/settings", {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((res) => {
                    // this.meetingTypesList = res;
                    this.allSettings = res.data;
                    this.userIdSettings = this.allSettings.field_executives;
                    this.teamLeadList = this.allSettings.team_leads;
                    this.managerList = this.allSettings.manager;
                    // this.enquiryList = this.allSettings.field_executives;
                    // console.log(this.allSettings,"all settings");
                    this.isDeleteAvailable = this.allSettings.can_delete;
                    for (var i = 0; i < Object.keys(res.data.meeting_types).length; i++) {
                        this.meetingTypesList.push({
                            "text": Object.keys(res.data.meeting_types)[i],
                            "value": res.data.meeting_types[Object.keys(res.data.meeting_types)[i]]
                        })
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        AdvancedFilter() {
            const sendData = decodeMeetingSearchParams(this.AdvancedFilterMeeting);
            let newQ = {
                ...sendData,
                is_advanced_search: true
            };
            this.$router.replace({
                query: newQ
            });
        },
        resetAdvancedFilter() {
            this.AdvancedFilterMeeting = {
                enquiry_no: [],
                start_date: null,
                end_date: null,
                client_name: [],
                tl_id: null,
                meeting_type: null,
                manager_id: []
            };
            let rQ = this.$route.query
            if (rQ.is_advanced_search) {
                this.$router.replace({
                    query: {}
                });
            }
        },
        resetFilter() {
            let rQ = this.$route.query;
            this.Filter = "";
            if (rQ.search_query) {
                let {
                    search_query,
                    ...newQ
                } = rQ;
                this.$router.replace({
                    query: newQ
                });
            }
        },
        FilterData() {
            if (this.Filter) {
                let newQ = {
                    ...this.$route.query,
                    search_query: this.Filter
                };
                this.$router.replace({
                    query: newQ
                });
            }
        },
        goToPage(pageNo) {
            let newQ = {
                ...this.$route.query,
                pageNo
            };
            this.$router.replace({
                query: newQ
            });
        }
    },
    computed: {
        totalPages() {
            if (this.total === 0 || this.perPage === 0) {
                return 0;
            } else {
                return Math.ceil(this.total / this.perPage);
            }
        },
        pageNo: {
            get() {
                let pageNo = this.$route.query.pageNo || 1
                return parseInt(pageNo);
            },
            set() {
                true;
            }
        },
        pageStart() {
            if (this.total === 0) {
                return 0;
            }
            return (Math.max(0, (this.pageNo - 1) * this.perPage + 1))
        },
        pageEnd() {
            if (this.total === 0) {
                return 0;
            }
            return (Math.min(this.total, this.pageNo * this.perPage))
        },
        FieldExecutiveList() {
            return this.$store.getters.FieldExecutiveMaster;
        },
        firmList() {
            let list = [];
            for (var i = 0; i < this.GetAllMeetings.length; i++) {
                list.push(this.GetAllMeetings[i].client_name);
            }
            console.log(list);
            return list;
        },
        broker_categorization() {
            return this.$store.getters.broker_categorization;
        }
    }
}
</script>
  
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
